module.exports = __webpack_public_path__ + "static/simple_login_icon-2cccb748872847658acaa8f07511d9b3.svg";